<template>
  <div class="courseSettings">
    <v-card dark>
      <v-card-title>
        Label-Verwaltung
        <v-spacer></v-spacer>
        <v-btn @click="openCreateDialog" color="primary">
          <v-icon left>mdi-plus</v-icon>
          Neues Label
        </v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="labels"
        :items-per-page="-1"
        :sort-by="'text'"
        :loading="isLoadingTable"
        class="elevation-1"
        no-data-text="Keine Labels gefunden."
        loading-text="Lade Labels...">
        <template v-slot:item.color="{ item }">
          <v-chip style="width: 50px" :color="item.color" :dark="isColorDark(item.color)"> </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="openEditDialog(item)"> mdi-pencil </v-icon>
          <v-icon small @click="openDeleteDialog(item, 'label')"> mdi-delete </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="editDialog" max-width="500px" persistent>
      <v-card dark>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="editedItem.text" label="Label-Text" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <v-text-field v-if="false" v-model="editedItem.color" label="Farbe (HEX)" outlined dense hide-details class="mr-4"></v-text-field>
                <v-menu v-if="false" v-model="colorMenu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <div
                      :style="{
                        backgroundColor: editedItem.color,
                        width: '36px',
                        height: '36px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        border: '1px solid grey',
                      }"
                      v-on="on" />
                  </template>
                  <v-card>
                    <v-color-picker
                      v-model="editedItem.color"
                      :swatches="swatches"
                      show-swatches
                      hide-canvas
                      hide-inputs
                      hide-mode-switch
                      hide-sliders
                      flat></v-color-picker>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeEditDialog">Abbrechen</v-btn>
          <v-btn color="primary" text :loading="isSaving" @click="saveLabel">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="350">
      <v-card dark>
        <v-card-title class="text-h5"> '{{ shorten(deleteDialogTitle, 25) }}' löschen? </v-card-title>
        <v-card-text v-if="deleteDialogPreText" class="red--text font-weight-bold">
          Wird in folgenden Studios verwendet: {{ deleteDialogPreText }}
        </v-card-text>
        <v-card-text>
          Möchtest du {{ getTextbyType(deleteDialogType) }}
          <strong>{{ shorten(deleteDialogTitle, 25) }}</strong>
          wirklich endgültig löschen?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Abbrechen</v-btn>
          <v-btn color="red darken-1" text :loading="isDeleting" @click="confirmDelete"> Löschen </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../../api"
import userService from "../../../services/userService"

export default {
  name: "courseSettings",
  data() {
    return {
      isLoadingTable: false,
      isSaving: false,
      isDeleting: false,

      userService,
      labels: [],

      editDialog: false,
      editedIndex: -1,
      editedItem: {
        text: "",
        code: "",
        color: "#00963f",
      },
      defaultItem: {
        text: "",
        code: "",
        color: "#00963f",
      },
      colorMenu: false,

      headers: [
        { text: "Text", value: "text" },
        { text: "Farbe", value: "color", sortable: false },

        { text: "Aktionen", value: "actions", sortable: false, align: "end" },
      ],

      deleteDialog: false,
      deleteDialogTitle: "",
      dialogDeleteObj: {},
      deleteDialogType: "",
      deleteDialogPreText: "",

      swatches: [
        ["#FF0000", "#ff9257", "#550000"],
        ["#FFFF00", "#AAAA00", "#555500"],
        ["#000000", "#00963f", "#000000"],
        ["#00FFFF", "#00AAAA", "#005555"],
        ["#0000FF", "#0000AA", "#000055"],
      ],
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Neues Label erstellen" : "Label bearbeiten"
    },
  },
  async created() {
    await this.fetchLabels()
    this.$emit("finishedloading")
  },
  methods: {
    async fetchLabels() {
      this.isLoadingTable = true
      try {
        this.labels = await api.fetchGFLabels()
      } catch (error) {
        console.error("Fehler beim Laden der Labels:", error)
      } finally {
        this.isLoadingTable = false
      }
    },

    openCreateDialog() {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.editDialog = true
    },

    openEditDialog(item) {
      this.editedIndex = this.labels.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
    },

    closeEditDialog() {
      this.editDialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    async saveLabel() {
      if (this.isSaving) return
      this.isSaving = true

      // Interne Bezeichnung automatisch mit dem sichtbaren Text synchronisieren
      this.editedItem.code = this.editedItem.text

      try {
        if (this.editedIndex > -1) {
          await api.updateGFLabel(this.editedItem)
          Object.assign(this.labels[this.editedIndex], this.editedItem)
        } else {
          await api.createGFLabel(this.editedItem)
          await this.fetchLabels()
        }
        this.closeEditDialog()
      } catch (error) {
        console.error("Fehler beim Speichern des Labels:", error)
      } finally {
        this.isSaving = false
      }
    },

    async openDeleteDialog(item, type) {
      this.dialogDeleteObj = item
      this.deleteDialogType = type
      this.deleteDialogPreText = ""
      if (type === "label") {
        this.deleteDialogTitle = item.text
      }
      this.deleteDialog = true
    },

    async confirmDelete() {
      if (this.isDeleting) return
      this.isDeleting = true

      const entry = this.dialogDeleteObj
      const type = this.deleteDialogType

      try {
        if (type === "label") {
          await api.deleteGFLabel(entry._id)
          const index = this.labels.findIndex((label) => label._id === entry._id)
          if (index > -1) {
            this.labels.splice(index, 1)
          }
        }
        this.deleteDialog = false
        this.$nextTick(() => {
          this.dialogDeleteObj = {}
        })
      } catch (error) {
        console.error("Fehler beim Löschen des Labels:", error)
      } finally {
        this.isDeleting = false
      }
    },

    getTextbyType(type) {
      if (type === "label") return "das Label"
      if (type === "room") return "den Raum"
      if (type === "course") return "den Kurs"
    },
    shorten(text, length = 25) {
      if (!text) return ""
      if (text.length > length) text = text.substr(0, length) + "..."
      return text
    },
    isColorDark(hexColor) {
      if (!hexColor || hexColor.length < 7) return true
      const r = parseInt(hexColor.substr(1, 2), 16)
      const g = parseInt(hexColor.substr(3, 2), 16)
      const b = parseInt(hexColor.substr(5, 2), 16)
      const yiq = (r * 299 + g * 587 + b * 114) / 1000
      return yiq < 128
    },
  },
}
</script>

<style lang="scss" scoped>
/* Stile bleiben unverändert */
::v-deep .v-color-picker__edit,
:v-deep .v-color-picker__controls {
  display: none !important;
}
::v-deep .v-slide-group__prev {
  display: none !important;
}
</style>
